module.exports = __webpack_public_path__ + "static/schall_im_schilf2-03b55b2bb7e13dfc33dd61e5356f6826.jpg";